/**
 * Точка входа.
 *
 * Мок-бэкенд подключается ДО запуска приложения и только когда включён:
 * `import.meta.env.VITE_USE_MOCKS` подставляется Vite статически, поэтому
 * при `false` ветка вместе со всем каталогом `src/mocks` вырезается бандлером.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { MOCKS_ENABLED } from '@shared/api/transport'
import { captureInstallPrompt } from '@shared/pwa/install'
import '@shared/ui/tokens/index.css'

import { App } from './app/App'

/*
 * `beforeinstallprompt` приходит рано и ровно один раз (CLIENT_WEB.md §9.4 п. 2),
 * поэтому перехват ставится до монтирования React, а не в компоненте.
 */
captureInstallPrompt()

async function start(): Promise<void> {
  /*
   * CLIENT_IOS_WEBAPP.md §1.3: ниже порога поддержки iOS статический экран уже
   * нарисован классическим скриптом public/unsupported.js — приложение поверх
   * него не стартует, чтобы не заменить объяснение молчаливой поломкой.
   */
  if (document.documentElement.hasAttribute('data-unsupported-platform')) return

  if (MOCKS_ENABLED) {
    const { installMockBackend } = await import('@mocks/install')
    await installMockBackend()
  }

  const root = document.getElementById('root')
  if (!root) throw new Error('root element is missing')

  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
